import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import FilledButton from 'components/application/buttons/FilledButton';
import TextButton from 'components/application/buttons/TextButton';
import ModalBox from 'components/application/ModalBox';

import { resourceShape } from 'components/helpers/serialisableResources';

export default function BookingReminderModal({
  booking,
  course,
  isOpen,
  onClose,
  onSendReminderConfirmation,
  personnel,
}) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'training.BookingReminderModal',
  });

  const { t: i18nTCommon } = useTranslation('common');

  const onSendReminder = () => {
    onClose();
    onSendReminderConfirmation({ booking, course });
  };

  return (
    <ModalBox
      customFooter={
        <div className='modalbox__footer-actions modalbox__footer-actions--right'>
          <TextButton
            className='tw-mr-3'
            color='blue'
            onClick={onClose}
            size='md'
          >
            {i18nTCommon('shared.cancel')}
          </TextButton>
          <FilledButton color='mint' onClick={onSendReminder}>
            {i18nTCommon('shared.sendReminder')}
          </FilledButton>
        </div>
      }
      isOpen={isOpen}
      mode='flexible'
      onClose={onClose}
    >
      <div className='tw-p-8'>
        <h2 className='tw-m-0 tw-p-0 tw-text-l tw-font-semibold tw-text-grey-900'>
          {i18nT('title', {
            courseName: course?.attributes.name,
            interpolation: { escapeValue: false },
            name: personnel?.firstName,
          })}
        </h2>
        <p className='tw-mb-0 tw-ml-0 tw-mr-0 tw-mt-6 tw-p-0 tw-text-m tw-font-normal tw-text-grey-700'>
          {i18nTCommon('personnel.emailNotifications.personnel')}
        </p>
      </div>
    </ModalBox>
  );
}

BookingReminderModal.propTypes = {
  personnel: PropTypes.shape({
    firstName: PropTypes.string.isRequired,
  }),
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  booking: resourceShape('booking'),
  course: resourceShape('course'),
  onSendReminderConfirmation: PropTypes.func.isRequired,
};
